
window.ECV_CONFIGURATION='VF_FIXED';
console.log("ECV CONFIGURATION = VF_FIXED");
let modules = [
import('../modules/CoreModules/Demo'),
import('../modules/CoreModules/PureWebRTC'),
import('../modules/CoreModules/ExternalAdapter'),
import('../modules/CoreModules/Photo'),
import('../modules/CustomerModules/Vodafone/Fixed/Main'),];
export default modules;